/**
 * Address edit modal for InvoiceManager.
 * Extracted from InvoiceManager.
 */

export interface AddressModalProps {
  newBillingAddress: string;
  onSetNewBillingAddress: (v: string) => void;
  addressChangeReason: string;
  onSetAddressChangeReason: (v: string) => void;
  loading: boolean;
  onSave: () => void;
  onClose: () => void;
}

export default function AddressModal({
  newBillingAddress, onSetNewBillingAddress,
  addressChangeReason, onSetAddressChangeReason,
  loading, onSave, onClose,
}: AddressModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Billing Address</h2>
          <button onClick={onClose} className="modal-close">&times;</button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Billing Address</label>
            <textarea
              className="form-textarea"
              value={newBillingAddress}
              onChange={(e) => onSetNewBillingAddress(e.target.value)}
              placeholder="Enter complete billing address..."
              rows={4}
            />
          </div>

          <div className="form-group">
            <label className="form-label form-required">Reason for Change</label>
            <textarea
              className="form-textarea"
              value={addressChangeReason}
              onChange={(e) => onSetAddressChangeReason(e.target.value)}
              placeholder="e.g., Customer requested address correction..."
              rows={2}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn btn-secondary">
            Cancel
          </button>
          <button onClick={onSave} disabled={loading} className="btn btn-primary">
            Save Address
          </button>
        </div>
      </div>
    </div>
  );
}
